export default {
	methods: {
		async restoreTrackEffects(track, effects) {
			if (!this.audioSystem)
				this.initAudioSystem();

			return await this.audioSystem.restoreTrackEffects(track, effects);
		},
		async getPipelineEffects(aggregatedTrack, customAudioContext, runtimeWapiPlugins) {
			if (!this.audioSystem)
				this.initAudioSystem();

			return await this.audioSystem.getPipelineEffects(aggregatedTrack, customAudioContext, runtimeWapiPlugins);
		}
	}
};
